import { graphql, useStaticQuery } from "gatsby"

const useTestimonials = () => {
  return useStaticQuery(graphql`
    query TestimonialsQuery {
      allStrapiTestimonials {
        nodes {
          at_munzing_since
          strapiId
          name
          location {
            key
          }
          position {
            key
          }
          segment {
            key
          }
          description {
            key
          }
          image {
            image {
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(width: 960, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
  `).allStrapiTestimonials.nodes.map((testimonial) => {
    return {
      ...testimonial,
      atMunzingSince: new Date(testimonial.at_munzing_since),
    }
  })
}

export default useTestimonials
